import React, { useEffect } from "react";
import { RequestStatus } from '../api_request/api_request';
import { classNameMap, ModelClass } from "../rest/models";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { downloadDict } from "../rest/data";
import { makePlainObject } from "../utils";
import { restActions } from "../rest/slice";

export function PleaseWait(props: {what: string})
{
    return <div className='ernots_PleaseWait'>Please wait, loading {props.what}...</div>
}

export function NothingToShow(props: {what: string})
{
    return <div className='ernots_NothingToShow'>No {props.what} to display.</div>
}

interface RequestStatusDisplayParams
{
    processing_message?: React.ReactNode;
    success_message?: React.ReactNode;
    error_message?: React.ReactNode;
    require_status?: number;
    error_wrong_status_message?: React.ReactNode;
    style?: React.CSSProperties;
}

export function RequestStatusDisplay(props: RequestStatusDisplayParams & {request?: RequestStatus})
{
    const {request, processing_message, success_message, error_message, require_status, error_wrong_status_message} = props;

    function get_ret(msg?: React.ReactNode, success?: boolean)
    {
        msg ??= request?.message;

        if (typeof msg === 'object')
        {
            //Usually a JSX.Element.
            return msg;
        }

        return (
        <div
            style={{whiteSpace: 'pre', ...props.style}}
            className='ernots_RequestStatusDisplay'
            data-success={success + ""}
            children={msg}/>)
    }
    
    let ret = <></> as React.ReactNode;
    if (request)
    {
        if (!request.finished)
        {
            ret = get_ret(processing_message);
        }
        else if (require_status && request.statusCode !== require_status)
        {
            ret = get_ret(error_wrong_status_message, false);
        }
        else if (request.success)
        {
            ret =  get_ret(success_message, true);
        }
        else
        {
            ret = get_ret(error_message, false);
        }
    }

    return ret;
}

export function DictRequestStatusDisplay(props: {modelClass: ModelClass, processing_message?: string, inline?: boolean})
{
    const appDispatch = useAppDispatch();

    const mcn = classNameMap[props.modelClass.name]
    const request = useAppSelector((state) => state.rest[mcn]?.request);
    const setRequest = function(rs: RequestStatus)
    {
        rs = makePlainObject(rs);
        const update = {modelClassName: mcn, request: rs};
        appDispatch(restActions.setRequest(update))
    }

    useEffect(function()
    {
        if (!request || (request.finished && !request.success))
        {
            downloadDict(props.modelClass, appDispatch, setRequest);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const processing_message0 = props.processing_message
        ?? ` ${mcn} objects...`;

    const processing_message = props.inline
        ? <>{processing_message0}</>
        : <div>{processing_message0}</div>;
    return RequestStatusDisplay({request, processing_message, success_message: <></>});
}

/** Marks required items */
export function Valid(props: {children: React.ReactNode, bValid: any })
{
    const {children, bValid} = props
    return bValid ? <></> : <div className='ernots_Warning'>{children}</div>;
}